import { dateToStr } from "@util/date-utils";

export function addCls(elem:any,cls:string) {
  elem && elem.classList && elem.classList.add(cls);
}

export function getFileName(fileExtension: string) {
  var d = new Date();
  var ds = dateToStr(d, true);
  return 'video-' + ds + '.' + fileExtension;
}
